
import { NgModule } from '@angular/core';
import { DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxLookupModule, DxSelectBoxComponent, DxSelectBoxModule, DxTextBoxModule, DxTreeListModule, DxTreeViewModule, DxChartModule, DxPivotGridModule, DxButtonModule } from 'devextreme-angular';

const devexpresComponents = [

    DxTreeListModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDataGridModule,
    DxTextBoxModule,
    DxLookupModule,
    DxDateBoxModule,
    DxSelectBoxModule,
    DxChartModule,
    DxPivotGridModule,
    DxButtonModule

];

@NgModule({
    imports: [...devexpresComponents],
    exports: [...devexpresComponents],

})
export class DevExtremesModule { }
